import styled from 'styled-components';

import {
  ModalProps,
  Modal as BaseModal,
  ModalTitle as BaseModalTitle,
} from '#/components/shared/Modal';

export { ModalHeader, ModalCloseButton } from '#/components/shared/Modal';

const MODAL_TITLE_ID = 'wallet-modal-title';

export function Modal(props: ModalProps) {
  return (
    <BaseModal {...props} aria-labelledby={MODAL_TITLE_ID}>
      <div css="display: grid; gap: 16px;">{props.children}</div>
    </BaseModal>
  );
}

export const ModalTitle = styled(BaseModalTitle).attrs({
  id: MODAL_TITLE_ID,
})``;
